export default {
    countries: ({ countries }) => countries,
};
